import { ReactNode } from 'react';

export interface TabItem {
  key: string;
  label: ReactNode;
  count?: number;
}

interface TabsProps {
  items: TabItem[];
  activeKey: string;
  onChange: (key: string) => void;
  /** When true, places a vertical separator after the tabs (used inside PageToolbar). */
  separator?: boolean;
}

export function Tabs({ items, activeKey, onChange, separator }: TabsProps) {
  return (
    <div className={`flex gap-0.5 ${separator ? 'pr-3 border-r border-border' : ''}`}>
      {items.map((item) => {
        const isActive = item.key === activeKey;
        return (
          <button
            key={item.key}
            type="button"
            onClick={() => onChange(item.key)}
            className={`flex items-center gap-1.5 px-[11px] py-[5px] rounded-md text-[12.5px] font-medium cursor-pointer transition-colors border-none ${
              isActive
                ? 'bg-text text-panel'
                : 'bg-transparent text-text-2 hover:text-text hover:bg-bg-elevated'
            }`}
          >
            <span>{item.label}</span>
            {item.count != null && (
              <span
                className={`font-mono text-[10px] font-semibold leading-none px-1.5 py-[3px] rounded-md ${
                  isActive
                    ? 'bg-white/20 text-white'
                    : 'bg-bg-elevated text-text-3 border border-border'
                }`}
              >
                {item.count.toLocaleString()}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
